import { isNullOrUndefined } from "../../../utils/todo-utils";
import { SET_USER_SETTINGS } from "../../actions/Settings/saveSettingAction";

const initialState = {
    aiAssistant: false,
    zoomLevel: 10,
    theme: 'light',
    defaultView: 'Overview',
    showVisualSize: true,
    showDueDate: true,
    showTaskProgress: true
};

const setUserSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_SETTINGS:
            return {
                ...state,
                aiAssistant: action.payload ? isNullOrUndefined(JSON.parse(action.payload.aiAssistant)) ? false : JSON.parse(action.payload.aiAssistant) : null,
                zoomLevel: action.payload ? action.payload.zoomLevel : null,
                theme: action.payload ? action.payload.theme : null,
                defaultView: action.payload ? isNullOrUndefined(action.payload.defaultView) ? "Overview" : action.payload.defaultView : null,
                showDueDate: action.payload ? isNullOrUndefined(JSON.parse(action.payload.showDueDate)) ? false : JSON.parse(action.payload.showDueDate) : null,
                showVisualSize: action.payload ? isNullOrUndefined(JSON.parse(action.payload.showVisualSize)) ? false : JSON.parse(action.payload.showVisualSize) : null,
                showTaskProgress: action.payload ? isNullOrUndefined(JSON.parse(action.payload.showTaskProgress)) ? false : JSON.parse(action.payload.showTaskProgress) : null
            };
        case 'SET_ZOOM_LEVEL':
            return {
                ...state,
                zoomLevel: action.payload
            };
        case 'SET_AI_ASSISTANT':
            return {
                ...state,
                aiAssistant: action.payload
            };
        case 'SET_SHOW_DUEDATE':
            return {
                ...state,
                showDueDate: action.payload
            };
        case 'SET_SHOW_VISUALSIZE':
            return {
                ...state,
                showVisualSize: action.payload
            };
        case 'SET_SHOW_TASK_PROGRESS':
            return {
                ...state,
                showTaskProgress: action.payload
            };
        default:
            return state;
    }
};

export default setUserSettingsReducer;